import React from "react";
import "./Description.css";


function Description({ productDesc }) {
  return (
    <div className="description-containers">
      <div className="description-combine">
        <div className="description-container-desc-points">
          {productDesc &&
            productDesc[0]?.descriptions_points &&
            productDesc[0]?.descriptions_points.map((point, index) => (
              <ul key={index}>
                <li className="description-container-desc-each-point">
                  {point}
                </li>
              </ul>
            ))}
        </div>
        {productDesc && productDesc[0]?.features && (
          <div className="description-container-features-div">
            <h3 className="features-heading">Features:</h3>
            <ul>
              {productDesc &&
                productDesc[0]?.features &&
                productDesc[0]?.features?.map(
                  (feature, index) =>
                    feature.length > 0 && <li key={index}>{feature}</li>
                )}
            </ul>
          </div>
        )}
      </div>
      <div className="w-full md:w-1/2 flex max-md:flex-col items-start justify-start gap-2">
        {productDesc &&
          productDesc[0]?.descriptions_images &&
          productDesc[0]?.descriptions_images?.map((img, index) => (
            <div
              key={index}
              className="w-full h-[300px] sm:h-[250px] xs:h-[200px] overflow-hidden"
            >
              <img
                loading="lazy"
                src={`https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_PRODUCT_DESCRIPTION_IMAGE/${img}`}
                alt="description_image"
                className="w-full h-full object-contain"
              />
            </div>
          ))}
      </div>
    </div>
  );
}

export default Description;
